module.exports = __webpack_public_path__ + "media/images/icons/typing-47cf2cd73622c5092de84b8e43d63e41.gif";